import { DateValue } from './date-value';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

export const dateFormat = (date: DateValue, format: string): string => {
  return dayjs(date).locale('pl').format(format);
};
